import React, { useEffect, useState } from "react";
import { Card, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { postMultipartWithAuthCallWithErrorResponse, simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate, useParams } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Country } from "country-state-city";



function NewSupplier() {
  const navigate = useNavigate();
   const { id } = useParams(); // supplier id from route

  /* ---------------- STATE ---------------- */
  const [form, setForm] = useState({
    supplier_name: "",
    supplier_address: "",
    supplier_city: "",
    supplier_nationality: "India",
    supplier_email: "",
    supplier_mobile: "",
    image: null,
  });
const [countries, setCountries] = useState([]);
const [countryCode, setCountryCode] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  useEffect(() => {
  const allCountries = Country.getAllCountries().map((c) => ({
    name: c.name,
    isoCode: c.isoCode,
    phonecode: `+${c.phonecode}`,
    flag: c.flag
  }));

  setCountries(allCountries);
}, []);
  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setForm((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  /* ---------------- VALIDATION ---------------- */
  const validateForm = () => {
    const newErrors = {};

    if (!form.supplier_name.trim()) {
      newErrors.supplier_name = "Supplier name is required";
    }

    if (!form.supplier_email.trim()) {
      newErrors.supplier_email = "Email is required";
    }

    if (!form.supplier_mobile.trim()) {
      newErrors.supplier_mobile = "Contact number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------------- SUBMIT ---------------- */
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    toast.error("Please fix the errors below");
    return;
  }

  setLoading(true);

  const formData = new FormData();

  // 🔑 Required auth fields
  formData.append("customer_id", Number(localStorage.getItem("customer_id")));
  formData.append("api_key", localStorage.getItem("api_key"));
  formData.append("language", "en");

  // 🔑 Supplier fields
  formData.append("supplier_name", form.supplier_name);
  formData.append("supplier_address", form.supplier_address);
  formData.append("supplier_city", form.supplier_city);
  formData.append(
  "supplier_mobile",
  `${countryCode}${form.supplier_mobile}`
);
const selectedCountry = countries.find(
  (c) => c.isoCode === form.supplier_nationality
);

formData.append(
  "supplier_nationality",
  selectedCountry?.name || "-"
);

  formData.append("supplier_email", form.supplier_email);

  // 🔥 IMAGE AS BINARY
  if (form.image) {
    formData.append("image", form.image); // File object
  }
  if(id) formData.append("supplier_id", id);

  const url = id ? ApiConfig.supplierEditPost :  ApiConfig.supplierCreatePost

  try {
    const response = await postMultipartWithAuthCallWithErrorResponse(
     url,
      formData,        // ⬅️ NOT JSON.stringify
      true             // ⬅️ tells API service it's multipart/form-data
    );

    console.log('response.result--', response.json.result)

    if (response?.json.result) {
      toast.success( response?.json.message ||"Supplier created successfully");
      setTimeout(() => navigate("/accountant/Suppliers"), 1);
    } else {
      toast.error(response?.json.message || "Failed to create supplier");
 

    }
  } catch (error) {
    console.error("Create supplier error:", error);
    toast.error("Network error occurred");
  } finally {
    setLoading(false);
  }
};


 useEffect(() => {
    if(id && countries?.length > 0){
    fetchSupplierDetails();
    }
  }, [id, countries]);

 const splitMobileNumber = (fullNumber = "", countryList = []) => {
  
  if (!fullNumber.startsWith("+") || !countryList.length) {
    return { code: "", number: fullNumber };
  }
 

  const digits = fullNumber.replace("+", "");

  const match = countryList.find((c) =>
    digits.startsWith(c.phonecode.replace("+", ""))
  );

  if (!match) {
    return { code: "", number: digits };
  }

  return {
    code: match.phonecode,
    number: digits.replace(match.phonecode.replace("+", ""), ""),
    isoCode: match.isoCode,
  };
};


  const fetchSupplierDetails = async () => {
    setLoading(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.supplierView,
        JSON.stringify(requestBody)
      );

      if (response?.result && response?.data?.length > 0) {
        const supplier = response.data[0];

const mobileInfo = splitMobileNumber(
  supplier.supplier_mobile,
  countries
);

  setForm({
    ...form,
    supplier_name: supplier.supplier_name || "",
    supplier_address: supplier.supplier_address || "",
    supplier_city: supplier.supplier_city || "",
    supplier_email: supplier.supplier_email || "",
    supplier_mobile: mobileInfo.number || "",
    supplier_nationality: mobileInfo.isoCode || supplier.supplier_nationality || "",
    image: supplier,
  });

  setCountryCode(mobileInfo.code || "");
      } else {
    
      }
    } catch (error) {
      console.error("Supplier view error:", error);
    
    } finally {
      setLoading(false);
    }
  };


  /* ---------------- UI ---------------- */
  return (
    <div className="container-fluid py-4">
            <ToastContainer position="top-right" autoClose={3000} />
      {/* HEADER */}
      <div className="bg-white p-3 rounded shadow-sm mb-3">
        <h5 className="mb-0 fw-bold">{id ? "Update Supplier" : 'New Supplier'} </h5>
      </div>

      {/* FORM CARD */}
      <Card className="shadow-sm" style={{ backgroundColor: "#fff" }}>
        <Card.Body>
          <Form noValidate onSubmit={handleSubmit}>
            {/* NAME */}
            <Row className="mb-3">
              <Col md={12}>
                <Form.Label>
                  Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  name="supplier_name"
                  value={form.supplier_name}
                  onChange={handleChange}
                  isInvalid={!!errors.supplier_name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.supplier_name}
                </Form.Control.Feedback>
              </Col>
            </Row>

            {/* ADDRESS + CITY */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="supplier_address"
                  value={form.supplier_address}
                  onChange={handleChange}
                />
              </Col>

              <Col md={6}>
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="supplier_city"
                  value={form.supplier_city}
                  onChange={handleChange}
                />
              </Col>
            </Row>

            {/* NATIONALITY */}
            <Row className="mb-3">
              <Col md={6}>
                {/* <Form.Label>Nationality</Form.Label>
                <Form.Select
                  name="supplier_nationality"
                  value={form.supplier_nationality}
                  onChange={handleChange}
                >
                  <option>India</option>
                  <option>United States</option>
                  <option>United Kingdom</option>
                </Form.Select> */}

                {/* <Form.Group>
  <Form.Label>
    Contact Number <span className="text-danger">*</span>
  </Form.Label>

  <PhoneInput
    country={"in"}          // default country
    enableSearch            // searchable dropdown
    value={form.supplier_mobile}
    onChange={(value, country) => {
      setForm((prev) => ({
        ...prev,
        supplier_mobile: value,               // full number
        supplier_nationality: country.name,   // country name
      }));
    }}
    inputStyle={{
      width: "100%",
      height: "38px",
    }}
    containerStyle={{ width: "100%" }}
  />
</Form.Group> */}
<Form.Label>Nationality</Form.Label>
<Form.Select
  value={form.supplier_nationality}
  onChange={(e) => {
    const selected = countries.find(
      (c) => c.isoCode === e.target.value
    );

    setForm((prev) => ({
      ...prev,
      supplier_nationality: selected?.isoCode || "", // ✅ STORE isoCode
      
    }));

    setCountryCode(selected?.phonecode || "");
  }}
>
  <option value="">Select Nationality</option>

  {countries.map((country) => (
    <option key={country.isoCode} value={country.isoCode}>
      {country.flag} {country.name}
    </option>
  ))}
</Form.Select>


              </Col>
            </Row>

            {/* EMAIL + CONTACT */}
            <Row className="mb-3">
              <Col md={6}>
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  name="supplier_email"
                  value={form.supplier_email}
                  onChange={handleChange}
                  isInvalid={!!errors.supplier_email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.supplier_email}
                </Form.Control.Feedback>
              </Col>

              <Col md={6}>
                <Form.Label>
                  Contact Number <span className="text-danger">*</span>
                </Form.Label>
                <div className="d-flex">
               <Form.Control
  type="text"
  className="ms-2"
  value={countryCode}
  disabled
  onChange={(e) =>
    setCountryCode(e.target.value)
  }
/>
                  <Form.Control
                    type="text"
                    className="ms-2"
                    name="supplier_mobile"
                    value={form.supplier_mobile}
                    onChange={handleChange}
                    isInvalid={!!errors.supplier_mobile}
                  />
                </div>
                <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                  {errors.supplier_mobile}
                </Form.Control.Feedback>
              </Col>
            </Row>

            {/* LOGO */}
            <Row className="mb-4">
              <Col md={6}>
                <Form.Label>Logo</Form.Label>
                <Form.Control type="file" onChange={handleFileChange} />
              </Col>
            </Row>

            {/* ACTION */}
            <Row>
              <Col className="text-end">
                <Button style={{backgroundColor: "#53b7e8", border: "none"}} type="submit" disabled={loading}>
                  {loading ? <Spinner size="sm" /> : id ? "Update" : "Create"}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}

export default NewSupplier;
